Namespace 'Monitoring.Views.SocialContents'

class Common.Sessions.SessionListItemView extends Backbone.View
  template: JST['backbone/templates/common/sessions/session_list_item']

  events:
    'click .remove_session': 'showRemoveConfirmation'

  initialize: ({session, sessions}) ->
    @session = session
    @sessions = sessions

  render: ->
    @$el.html @template
      session: @session
      sessionName: @getSessionName(@session)
      sessionDate: @getSessionDate(@session)
    @

  getSessionName: (session) ->
    return session.get('name')

  getSessionDate: (session) ->
    return moment(new Date(session.get('updated_at'))).format('DD/MM/YYYY - HH:mm')

  showRemoveConfirmation: (event) =>
    swal
      title: I18n.t 'monitoring.dashboard.session.modal_delete'
      type: 'warning'
      showCancelButton: true
      confirmButtonClass: 'btn-danger'
      confirmButtonText: I18n.t 'monitoring.dashboard.session.s_yes'
      cancelButtonText: I18n.t 'monitoring.dashboard.session.s_cancel'
      closeOnConfirm: true
      customClass: 'common'
      => @sessions.destroy(@session)
